import { GetClientId, RandomString } from "./clientid";

const PING_INTERVAL: number = 60 * 1000; // Every minute

const sessionId = new BigUint64Array(1);
window.crypto.getRandomValues(sessionId);

export function StartPingTimer(page: string, extraData: () => {}): void {
    const url = 'https://ping.liveresultater.no/ping.php';
   
    const doPing = function() {
        const data = {
            'page': page,
            'referer': document.referrer,
            'session_id': sessionId[0].toString(),
            'extra_data': extraData()
        };
        
        let xmlHttp = new XMLHttpRequest();
        xmlHttp.open("POST", url);
        xmlHttp.send(JSON.stringify(data));
    };

    doPing();
    setInterval(doPing, PING_INTERVAL);
}
